function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.4,
    viewBox: "0 0 18 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.9 11.7a.9.9 0 0 1-.1-1.794L.9 9.9h9.9a2.7 2.7 0 0 1 2.7-2.7h1.8A2.7 2.7 0 0 1 18 9.9v1.8a2.7 2.7 0 0 1-2.7 2.7h-1.8a2.7 2.7 0 0 1-2.7-2.7zM15.3 9h-1.8a.9.9 0 0 0-.894.8l-.006.1v1.8a.9.9 0 0 0 .8.894l.1.006h1.8a.9.9 0 0 0 .894-.8l.006-.1V9.9a.9.9 0 0 0-.8-.894zM4.5 0a2.7 2.7 0 0 1 2.7 2.7h9.9a.9.9 0 0 1 .1 1.794l-.1.006H7.2a2.7 2.7 0 0 1-2.7 2.7H2.7A2.7 2.7 0 0 1 0 4.5V2.7A2.7 2.7 0 0 1 2.7 0zm0 1.8H2.7a.9.9 0 0 0-.894.8l-.006.1v1.8a.9.9 0 0 0 .8.894l.1.006h1.8a.9.9 0 0 0 .894-.8l.006-.1V2.7a.9.9 0 0 0-.8-.894z",
    style: {
      fill: "#0a243f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.12ef2335b131efa0e7a51c0135aea0d5.svg";
export { ForwardRef as ReactComponent };